import { render } from "./MultiProspettoCicloPagamenti.vue?vue&type=template&id=09b39fd3&scoped=true"
import script from "./MultiProspettoCicloPagamenti.vue?vue&type=script&lang=js"
export * from "./MultiProspettoCicloPagamenti.vue?vue&type=script&lang=js"

import "./MultiProspettoCicloPagamenti.vue?vue&type=style&index=0&id=09b39fd3&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b39fd3"]])

export default __exports__